import { ApiHandlerNoApiParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrandByPath";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";
import { getBrandByPath } from "@tCentro/Services/BrandServiceExtension";

export interface LoadBrandByPathParameter {
    path: string;
}

type HandlerType = ApiHandlerNoApiParameter<LoadBrandByPathParameter, BrandModel>;

export const RequestDataFromApiExtended: HandlerType = async props => {
    try {
        const brand = await getBrandByPath(props.parameter);
        props.apiResult = brand;
    } catch (error) {
        if (error?.status === 404) {
            return;
        }
        throw error;
    }
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiExtended);